/* eslint-disable max-len */
export const it = {
  user: {
    'tag-title': 'Voverc webapp - utente',
    extension: 'Interno',
    credit: 'Credito residuo',
    title1: 'PROFILO',
    contacts: 'Rubrica telefonica',
    number: 'Numero in uscita',
    settings: 'Pannello di controllo',
    title2: 'SUPPORTO',
    chat: 'Chatta con noi',
    phone: 'Chiamaci',
    email: 'Mandaci una email',
    tools: 'Strumenti di supporto',
    'bring-a-friend': 'Porta un amico',
    'global-call-history': 'Chiamate aziendali',
  },
  contacts: {
    'tag-title': 'Voverc webapp - rubrica',
    title: 'Rubrica',
    tabs: {
      internals: 'Interni',
      shared: 'Condivisi',
      'no-results': 'Nessun contatto trovato',
    },
    shared: {
      prev: 'Indietro',
      next: 'Avanti',
      fetch: 'Riprova',
      error:
        "C'è stato un problema nel recuperare i contatti. Prova ancora più tardi o contatta il supporto se il problema persiste",
    },
    details: {
      phones: {
        title: 'Numeri di telefono',
        labels: {
          PRIMARY: 'Primario',
          SECONDARY: 'Secondario',
          MOBILE: 'Cellulare',
          HOME: 'Casa',
          JOB: 'Lavoro',
          OTHER: 'Altro',
        },
      },
      emails: {
        title: 'Email',
        labels: {
          PRIMARY: 'Primario',
          SECONDARY: 'Secondario',
          HOME: 'Casa',
          JOB: 'Lavoro',
          OTHER: 'Altro',
        },
      },
      country: 'Paese',
      city: 'Città',
      province: 'Provincia',
      'postal-code': 'CAP',
      street: 'Strada',
      address: 'Indirizzo',
      'company-name': 'Nome azienda',
      'job-title': 'Posizione',
      website: 'Sito web',
      'no-phones': 'Questo contatto non ha numeri di telefono',
      'no-emails': 'Questo contatto non ha email',
    },
    search: {
      options: {
        'full-name': 'Nome completo',
        'phone-number': 'Numero di telefono',
      },
    },
  },
  number: {
    'tag-title': 'Voverc webapp - numero',
    number: 'Numero in uscita',
    question: 'Quale numero vuoi che appaia quando chiami?',
    'temporary-number-message': 'Questo è un numero temporaneo.\nLe tue chiamate in uscita saranno anonime.',
    'failed-outbound-message': 'Impossibile impostare il numero in uscita. Riprova.',
    'failed-to-load-message': 'Impossibile ottenere numeri in uscita disponibili. Riprovare.',
    retry: 'Riprova',
  },
  tools: {
    title: 'Strumenti di supporto',
    title1: 'PROFILO',
    renew: 'Aggiorna profilo voce',
  },
  'error-message': {
    '400':
      "Ci dispiace. Si è verificato un errore di autenticazione durante il recupero dei dati. Prova a riavviare l'app o ad effettuare nuovamente il login.",
    '500':
      "Ci dispiace molto. Si è verificato un errore del server. Siamo già al lavoro per risolverlo. Prova a riavviare l'app o ad effetuare nuovamente il login.",
    'problem-persists': 'Se il problema persiste, per favore',
  },
  'bring-a-friend': {
    messages: {
      success: 'Il link di invito è stato inviato con successo!',
      error: "Si è verificato un problema durante l'invio dell'invito, riprova più tardi.",
    },
    header: {
      title: 'Ricevere in regalo un mese gratuito non è mai stato così semplice!',
    },
    illustration: {
      'img-url': 'assets/img/top_illustration.png',
    },
    steps: {
      'step-1': {
        title: 'Invia il link ai tuoi amici',
        'img-url': 'assets/img/icon_link.png',
      },
      'step-2': {
        title: "Il tuo amico accetta l'invito",
        'img-url': 'assets/img/icon_accept.png',
      },
      'step-3': {
        title: 'Entrambi ottenete 1 mese gratis in regalo!',
        'img-url': 'assets/img/icon_free_month.png',
      },
    },
    share: {
      text: 'Condividi il tuo link di riferimento con i tuoi amici:',
      form: {
        errors: {
          required: 'Campo obbligatorio',
          email: 'Email non valida',
        },
        name: {
          label: 'Nome',
          placeholder: 'es. Mario',
        },
        email: {
          label: 'Email',
          placeholder: 'mario@company.com',
        },
        button: 'Spedire',
      },
    },
  },
  'bring-a-friend-new': {
    disclaimer: {
      title: 'Invita un amico:',
      subtitle: 'se sceglierà Voxloud, entrambi ottenete 250€',
    },
    steps: {
      contact: {
        title: 'Passaci il contatto',
        description:
          'Parla con il tuo Specialista e condividi con noi le informazioni di contatto di chi pensi possa trarre vantaggio da Voxloud.',
      },
      customer: {
        title: 'Il tuo amico diventa cliente Voxloud',
        description: 'Parlaremo con il tuo amico e capiremo se Voxloud fa al caso suo.',
      },
      gift: {
        title: 'Ricevi la gift card da 250€!',
        description: 'Il tuo amico diventa cliente Voxloud ed entrambi ricevete la gift card o il credito da 250€!',
      },
    },
    contact: {
      title: 'Passaci il contatto: al resto penseremo tutto noi!',
      call: {
        text: 'Chiamaci e invia i contatti del tuo amico',
        button: 'Chiamaci',
      },
      compile: {
        text: 'Compila il module con i contatti del tuo amico',
        button: 'Compila',
      },
    },
  },
  chat: {
    title: 'Inbox',
    error_generic:
      "Oops! Si è verificato un errore temporaneo durante l'inizializzazione della chat. Riprova e contatta il nostro team di supporto se il problema persiste.",
    error_disabled:
      'Il modulo Chat è disabilitato per il tuo account. Contatta il nostro team di supporto per assistenza.',
    error_not_found:
      "L'account del modulo Chat non è stato trovato. Contatta il nostro team di supporto per assistenza.",
    refresh: 'Aggiorna',
  },
  'global-call-history': {
    title: 'Chiamate aziendali',
  },
  events: {
    unanswered: 'Non risposta',
    'company-call-history': {
      table: {
        headers: {
          'phone-number': 'Numero telefonico',
          from: 'Da',
          to: 'A',
          actions: 'Azioni',
        },
        'no-records': 'Nessun evento trovato',
      },
      details: {
        table: {
          'phone-number': 'Numero telefonico:',
          from: 'Da:',
          to: 'A:',
          crm: 'CRM:',
          answerer: 'Ha risposto:',
          type: 'Tipo:',
          direction: 'Direzione:',
          date: 'Data:',
          duration: 'Durata:',
          'ring-time': 'Tempo di squillo:',
          rules: 'Regole:',
          labels: 'Etichette:',
        },
        ai: {
          headers: {
            'sentiment-score': 'Punteggio sentimento:',
            summary: 'Riassunto chiamata:',
            transcription: 'Trascrizione chiamata:',
          },
          'copy-text': {
            copy: 'Clicca per copiare',
            copied: 'Copiato!',
          },
        },
        tabs: {
          'tab-details': 'Panoramica',
          'tab-ai': 'Dati AI',
          'tab-webhooks': 'Webhooks',
          'tab-recording': 'Registrazione chiamate',
          'tab-voicemail': 'Segreteria telefonica',
          'tab-sms': 'SMS',
        },
        fields: {
          direction: {
            INBOUND: 'In entrata',
            OUTBOUND: 'In uscita',
            INTERNAL: 'Interna',
          },
          duration: {
            lost: 'Persa',
            unanswered: 'Non risposta',
            'busy-lines': 'Linee occupate',
          },
          type: {
            PHONE_CALL: 'PHONE CALL',
            CLICK_TO_CALL: 'CLICK TO CALL',
            FAX_CALL: 'FAX CALL',
            WHATSAPP: 'WHATSAPP',
          },
        },
        'call-recording': {
          disclaimer:
            'Questa registrazione rimane a tua disposizione in cloud per 4 mesi. In caso avessi bisogno di mantenerla per più tempo ti consigliamo di effettuare il download.',
        },
        voicemail: {
          disclaimer:
            'Questa registrazione rimane a tua disposizione in cloud per 4 mesi. In caso avessi bisogno di mantenerla per più tempo ti consigliamo di effettuare il download.',
        },
        'webhook-log': {
          table: {
            rule: 'Regola',
            attempts: 'Tentativi',
            'executed-at': 'Eseguito alle',
            status: 'Stato',
            'server-status': 'Codice risposta',
            'error-message': 'Messaggio di errore',
          },
        },
        sms: {
          text: 'Qui puoi trovare tutti gli SMS inviati durante la chiamata.<br> <b>Nota:</b> Potrebbe esserci più di un messaggio, a seconda della configurazione delle regole.',
          sender: 'Mittente',
          recipient: 'Destinatario',
          date: 'Data',
          'copy-text': {
            copy: 'Clicca per copiare negli appunti',
            copied: 'Copiato!',
          },
        },
      },
      filters: {
        and: 'e',
        units: {
          seconds: 'secondi',
          minutes: 'minuti',
        },
        apply: 'Applica filtri',
        clear: 'Cancella filtri',
        date_time_ranges: 'Tra le date',
        timezone: 'Fuso orario',
        did_number: 'Numero telefonico',
        status: 'Status',
        direction: 'Direzione',
        event_types: 'Tipo di chiamata',
        duration: 'Durata',
        ring_time: 'Tra i tempi di squillo',
        sentiment_score: 'Sentimento tra',
        destination_name: 'Nome destinatario',
        destination_number: 'Numero destinatario',
        originator_name: 'Nome chiamante',
        originator_number: 'Numero chiamante',
        answerer_name: 'Ha risposto (nome)',
        answerer_number: 'Ha risposto (numero)',
        voicemail: 'Con segreteria',
        recorded: 'Con registrazione chiamata',
        with_sms: 'Con SMS',
        is_ai_agent: 'Con AI Agent',
        user: 'Utente',
        'name-placeholder': 'Marco',
        'number-placeholder': '060606',
        options: {
          yes: 'Si',
          no: 'No',
          answered: 'Risposta',
          unanswered: 'Non risposta',
          phone_call: 'Chiamata',
          fax_call: 'Fax',
          click_to_call: 'Click-to-call',
          whatsapp: 'WhatsApp',
          inbound: 'In entrata',
          outbound: 'In uscita',
          internal: 'Interna',
          'all-dids': 'Tutti i numeri telefonici',
          'all-users': 'Tutti gli utenti',
          'no-options': 'Nessuna scelta disponibile',
        },
        popup: {
          title: 'Filtri',
        },
      },
    },
  },
  shared: {
    pagination: {
      'pages-label': 'Scegli la grandezza della pagina',
    },
  },
};
